import { Package, Clock, Users, Timer, Camera } from 'lucide-react';

type TabType = 'asis' | 'last_chance' | 'family_offers' | 'limited_time' | 'physical';

interface StoreProductTabsProps {
  activeTab: TabType;
  onTabChange: (tab: TabType) => void;
  counts: {
    asis: number;
    last_chance: number;
    family_offers: number;
    limited_time: number;
    physical: number;
  };
}

export function StoreProductTabs({ activeTab, onTabChange, counts }: StoreProductTabsProps) {
  const tabs = [
    {
      id: 'asis' as const,
      label: 'As-Is',
      icon: Package,
      count: counts.asis,
      color: 'blue',
    },
    {
      id: 'last_chance' as const,
      label: 'Last Chance',
      icon: Clock,
      count: counts.last_chance,
      color: 'orange',
    },
    {
      id: 'family_offers' as const,
      label: 'Family Offers',
      icon: Users,
      count: counts.family_offers,
      color: 'green',
    },
    {
      id: 'limited_time' as const,
      label: 'Limited Time',
      icon: Timer,
      count: counts.limited_time,
      color: 'red',
    },
    {
      id: 'physical' as const,
      label: 'Physical',
      icon: Camera,
      count: counts.physical,
      color: 'purple',
    },
  ];

  return (
    <div className="border-b border-gray-200">
      <nav className="flex gap-4">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`flex items-center gap-2 px-4 py-3 border-b-2 transition-colors ${
                isActive
                  ? `border-${tab.color}-500 text-${tab.color}-600`
                  : 'border-transparent text-gray-500 hover:text-gray-700'
              }`}
              style={
                isActive
                  ? {
                      borderColor:
                        tab.color === 'blue'
                          ? '#3b82f6'
                          : tab.color === 'orange'
                          ? '#f97316'
                          : tab.color === 'green'
                          ? '#22c55e'
                          : tab.color === 'red'
                          ? '#ef4444'
                          : '#a855f7',
                      color:
                        tab.color === 'blue'
                          ? '#2563eb'
                          : tab.color === 'orange'
                          ? '#ea580c'
                          : tab.color === 'green'
                          ? '#16a34a'
                          : tab.color === 'red'
                          ? '#dc2626'
                          : '#9333ea',
                    }
                  : undefined
              }
            >
              <Icon size={18} />
              <span className="font-medium">{tab.label}</span>
              <span
                className={`px-2 py-0.5 text-xs rounded-full ${
                  isActive
                    ? tab.color === 'blue'
                      ? 'bg-blue-100 text-blue-700'
                      : tab.color === 'orange'
                      ? 'bg-orange-100 text-orange-700'
                      : tab.color === 'green'
                      ? 'bg-green-100 text-green-700'
                      : tab.color === 'red'
                      ? 'bg-red-100 text-red-700'
                      : 'bg-purple-100 text-purple-700'
                    : 'bg-gray-100 text-gray-600'
                }`}
              >
                {tab.count.toLocaleString()}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
}
